// extracted by mini-css-extract-plugin
export default {"inputOfDatePicker":"styles_inputOfDatePicker__QSSp4","placeholder":"styles_placeholder__8-VZv"};